export function isInternalStaff(member) {
  return Boolean(member?.linkedWorkspaceUserId) || member?.tipoPersonale === 'interno';
}

export function getStaffInitials(name = '') {
  return name
    .split(' ')
    .filter(Boolean)
    .map((part) => part[0])
    .join('');
}

export function getStaffTypeMeta(type) {
  switch (type) {
    case 'interno':
      return {
        label: 'Interno',
        className: 'border-[var(--border-strong)] text-[var(--primary)] bg-[var(--primary-soft)]',
      };
    case 'esterno':
      return {
        label: 'Esterno',
        className: 'border-[var(--border)] text-[var(--chart-accent-1)] bg-[var(--chart-accent-1-soft)]',
      };
    default:
      return {
        label: type,
        className: 'border-[var(--border)] text-[var(--text-secondary)] bg-[var(--surface-raised)]',
      };
  }
}

export function filterStaffMembers(staffList, { searchTerm, filterTipo }) {
  return staffList.filter((member) => {
    const normalizedSearch = searchTerm.toLowerCase();
    const matchesSearch =
      member.name.toLowerCase().includes(normalizedSearch) ||
      member.role.toLowerCase().includes(normalizedSearch);
    const matchesType = filterTipo === 'tutti' || (isInternalStaff(member) ? 'interno' : 'esterno') === filterTipo;

    return matchesSearch && matchesType;
  });
}

export function getStaffCounters(staffList) {
  return {
    interni: staffList.filter((member) => isInternalStaff(member)).length,
    esterni: staffList.filter((member) => !isInternalStaff(member)).length,
  };
}

export function validateStaffForm(form) {
  if (!form.name || !form.role) {
    return 'Compila nome e ruolo';
  }

  const isExternal = form.accessType === 'external' || form.tipoPersonale === 'esterno';
  if (!isExternal && (!form.email || !form.phone)) {
    return 'Compila email e telefono per il personale interno';
  }

  return null;
}

export function buildStaffMemberPayload(form, nextId) {
  return {
    id: nextId,
    name: form.firstName !== undefined || form.lastName !== undefined
      ? [form.firstName, form.lastName].map(part => String(part || '').trim()).filter(Boolean).join(' ')
      : form.name,
    role: form.role,
    email: form.email,
    phone: form.phone,
    tipoPersonale: form.tipoPersonale,
    skills: (Array.isArray(form.skills) ? form.skills : String(form.skills || '').split(','))
      .map((item) => String(item || '').trim())
      .filter(Boolean),
    activeAssignments: [],
    completedAssignments: [],
  };
}

export function buildStaffMailtoHref(email = '') {
  const normalizedEmail = email.trim();
  return normalizedEmail ? `mailto:${normalizedEmail}` : '';
}

export function buildStaffTelHref(phone = '') {
  const normalizedPhone = phone.trim().replace(/\s+/g, '');
  return normalizedPhone ? `tel:${normalizedPhone}` : '';
}
